// strip lines breaks and forced line break backslashes
// used for titles in the nav menu/bookmarks/unit-end titles/etc.
export default function removeLinebreaks(text: string) {
  if (!text) return '';

  return text
    .replace(/ *\\?\n/g, ' ')
    .replace(/{r}/g, ' ')
    .replace(/{n}/g, ' ')
    .replace(/\n+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
